module.exports = __webpack_public_path__ + "static/media/fire_1.b2a82607.png";